export const trackFb = (event, params) => {
  try { if (window.fbq) window.fbq("track", event, params); } catch { /* pixel blocked — ignore */ }
};
